





























import { Component, Prop, Vue } from "vue-property-decorator";
import { ProgramPackTexts } from "../../bookings/programPackTexts";
import { GuidelineApi } from "../guidelines/guidelineApi";
import CzCard from "../cz/CzCard.vue";
import CzTitle from "../cz/CzTitle.vue";
import CzChip from "../cz/CzChip.vue";
import CzChoice from "../cz/CzChoice.vue";

// One line of "My treatment": name, brand, dose and until when on one line, the moments of today as pills to mark,
// the note, the next stages and the last seven days.
@Component({ components: { CzCard, CzTitle, CzChip, CzChoice } })
export default class TreatmentLineCard extends Vue {
  @Prop({ type: Object, required: true }) line!: any;
  @Prop({ type: Boolean, default: false }) busy!: boolean;

  get meta(): string {
    const when = this.line.state === "active" ? "" : this.line.when;
    return [this.line.dose, when, this.until()].filter((x: string) => x).join(" · ");
  }

  taken(slot: string): boolean {
    return this.line.takenToday.indexOf(slot) >= 0;
  }

  date(input: string): string {
    return new Intl.DateTimeFormat(ProgramPackTexts.culture(), { day: "numeric", month: "long" }).format(new Date(GuidelineApi.day(input) + "T12:00:00"));
  }

  until(): string {
    const line = this.line;
    if (line.state === "future") {
      return line.lastDay
        ? this.$t("From {0} until {1}").toString().replace("{0}", this.date(line.startDate)).replace("{1}", this.date(line.lastDay))
        : this.$t("Starts on {0}").toString().replace("{0}", this.date(line.startDate));
    }
    if (line.state === "ended") return this.$t("Ended on {0}").toString().replace("{0}", this.date(line.lastDay));
    return line.lastDay ? this.$t("Until {0}").toString().replace("{0}", this.date(line.lastDay)) : this.$t("Until we tell you").toString();
  }

  later(next: any): string {
    const what = [next.dose, next.when, next.note].filter((x: string) => x).join(" · ");
    return next.lastDay
      ? this.$t("Then {0} from {1} until {2}").toString().replace("{0}", what).replace("{1}", this.date(next.startDate)).replace("{2}", this.date(next.lastDay))
      : this.$t("Then {0} from {1}").toString().replace("{0}", what).replace("{1}", this.date(next.startDate));
  }

  dayClass(day: any): string {
    if (day.expected === 0) return "is-none";
    if (day.done >= day.expected) return "is-done";
    return day.done > 0 ? "is-partial" : "is-missed";
  }

  dayTitle(day: any): string {
    return this.date(day.date) + (day.expected ? ": " + this.$t("{0} of {1} taken").toString().replace("{0}", day.done).replace("{1}", day.expected) : "");
  }
}
